import '../../../../../../../Avency.Avency.Base/Resources/Private/Assets/JavaScript/Project/globals';

(function($, window, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function () {
        const beforeAfterImages = $('.before-after-image__wrapper');

        if ($(beforeAfterImages).length > 0) {
            $(beforeAfterImages).each(function () {
                $(this).find('.before-after-image__content').twentytwenty({
                    default_offset_pct: parseInt($(this).data('defaultoffset')) / 100,
                    orientation: $(this).data('orientation'),
                    before_label: $(this).data('beforelabel'),
                    after_label: $(this).data('afterlabel'),
                    no_overlay: $(this).data('showoverlay') !== 1,
                    move_slider_on_hover: $(this).data('movetype') === 'hover',
                    move_with_handle_only: false,
                    click_to_move: $(this).data('movetype') === 'click'
                });
            });
        }
    });
})(jQuery, window, window.PageLoadedQueue);
